import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { Row, Upload } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import styled from 'styled-components';
import { Button, Flex, Modal } from 'ui';

const StyledUpload = styled(Upload)`
  width: 100% !important;
  .ant-upload {
    width: inherit !important;
    height: 200px !important;
  };
  margin-bottom:  10px;
`;

const StyledModal = styled(Modal)`
  .ant-modal-header {
    text-transform: uppercase;
  }
`;

const BoldText = styled.span`
  font-weight: 900;
`;

const UploadModal = ({
  isLoading,
  visible,
  onClose,
  doFileUpload,
  intl,
  title,
  fileType,
}) => {
  const renderDropZone = () =>
    <Flex ffcn aic jcc>
      <div>
        {isLoading ? <LoadingOutlined /> : <PlusOutlined />}
      </div>
      <div
        className='ant-upload-text'
      >
        {isLoading ?
          `${intl.formatMessage({ id: 'fileUpload.UPLOADING' })}...` :
          <>
            <p>
              {intl.formatMessage(
                { id: 'fileUpload.DRAG_DROP' },
                {
                  fileType,
                  b: msg => <BoldText>{msg}</BoldText>,
                },
              )}
            </p>
            <p>
              {intl.formatMessage(
                { id: 'fileUpload.CLICK' },
                {
                  fileType,
                  b: msg => <BoldText>{msg}</BoldText>,
                },
              )}
            </p>
          </>
        }
      </div>
    </Flex>;
  return (
    <StyledModal
      title={title}
      open={visible}
      footer={null}
      onCancel={onClose}
    >
      <Row>
        <StyledUpload
          name='avatar'
          listType='picture-card'
          className='avatar-uploader'
          showUploadList={false}
          customRequest={doFileUpload}
          disabled={isLoading}
        >
          {renderDropZone()}
        </StyledUpload>
      </Row>
      <Flex jcfe>
        <Button
          disabled={isLoading}
          type='secondary'
          light
          onClick={onClose}
        >
          {intl.formatMessage({
            id: 'header.upload.CANCEL',
          })}
        </Button>
      </Flex>
    </StyledModal>
  );
};

UploadModal.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  doFileUpload: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  intl: PropTypes.object,
  title: PropTypes.string,
  fileType: PropTypes.string,
};

export default injectIntl(UploadModal);
